import { observer } from "mobx-react";
import { useTranslation } from "@/i18n";
import { WorkHoursForm } from "@/components/profile-settings/work-hours/work-hours-form";
import { SettingsPageShell } from "@/components/shared/settings-page-shell";

export const ProfileWorkHoursPage = observer(function ProfileWorkHoursPage() {
  const { t } = useTranslation();

  return (
    <SettingsPageShell
      title={t("profile_settings.work_hours.title")}
      description={t("profile_settings.work_hours.description")}
    >
      <WorkHoursForm />
    </SettingsPageShell>
  );
});
